import { ACCENT } from "@/config/theme";
import type { InsightDto } from "../types/weekly-cost-report.types";

export const ALL_CUSTOMERS_VALUE = "__ALL_CUSTOMERS__";
export const WEEKLY_COST_CUSTOMER_STORAGE_KEY = "cost_weekly_selected_customer";

/**
 * Returns service chart colors resolved from current theme.
 * Must be called inside a component or function (not at module scope)
 * to ensure colors reflect the active theme.
 */
export const getServiceColors = () => [
  ACCENT.chartBlue,
  ACCENT.purple,
  ACCENT.orange,
  ACCENT.yellow,
  ACCENT.pink,
];

// Fallback for non-browser contexts (tests, SSR)
export const CUSTOMER_STATUS_COLORS = {
  Review: {
    bg: "var(--bg-error-soft)",
    border: "var(--status-error)",
    text: "var(--status-info)",
  },
  Watch: {
    bg: "var(--bg-warning-soft)",
    border: "var(--status-warning)",
    text: "var(--status-info)",
  },
  Stable: {
    bg: "var(--bg-success-soft)",
    border: "var(--status-success)",
    text: "var(--status-info)",
  },
};

export const INSIGHT_ICON_MAP: Record<InsightDto["iconKey"], string> = {
  subscription: "pi pi-folder",
  service: "pi pi-server",
  growth: "pi pi-arrow-up-right",
  trend: "pi pi-chart-line",
  peak: "pi pi-bolt",
  forecast: "pi pi-chart-line",
};
